package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class ComparisonStats(
    val number: Int,
    val name: String,
    val npTotal: ComparisonStat,
    val auto: ComparisonStat,
    val teleop: ComparisonStat,
    val endgame: ComparisonStat,
    val gameSpecific: GameSpecificComparisonStats? = null,
) {
    constructor(number: Int, name: String) : this(number, name, EMPTY_COMPARISON_STAT, EMPTY_COMPARISON_STAT, EMPTY_COMPARISON_STAT, EMPTY_COMPARISON_STAT)
}

@Serializable
sealed class GameSpecificComparisonStats

@Serializable
data class FreightFrenzyComparisonStats(val alliance: ComparisonStat, val shared: ComparisonStat, val carousel: ComparisonStat) : GameSpecificComparisonStats()

@Serializable
data class FreightFrenzyCRIComparisonStats(val alliance: ComparisonStat, val shared: ComparisonStat, val coop: ComparisonStat) : GameSpecificComparisonStats()

@Serializable
data class IntoTheDeepComparisonStats(val specimen: ComparisonStat, val sample: ComparisonStat, val navigation: ComparisonStat) : GameSpecificComparisonStats()

@Serializable
data class IntoTheDeepCRIComparisonStats(val specimen: ComparisonStat, val sample: ComparisonStat, val navigation: ComparisonStat) : GameSpecificComparisonStats()

@Serializable
data class ComparisonStat(
    val oprn: Double,
    val stdev: Double,
    val min: Double,
    val max: Double,
)

val EMPTY_COMPARISON_STAT = ComparisonStat(0.0, 0.0, 0.0, 0.0)
val EMPTY_COMPARISON_STATS = ComparisonStats(-1, "", EMPTY_COMPARISON_STAT, EMPTY_COMPARISON_STAT, EMPTY_COMPARISON_STAT, EMPTY_COMPARISON_STAT)
